export * from './projeto-slice'